module.exports = __webpack_public_path__ + "static/media/icon_signup.d2e48545.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Support/components/imgs/icon_signup.svg
// module id = 825
// module chunks = 0